import clsx from 'clsx';
import type { OpslagStand } from '../../lib/kleed-tijdlijn';

function datumKort(iso: string | null): string {
  if (!iso) return '?';
  const [y, m, d] = iso.slice(0, 10).split('-');
  return y && m && d ? `${d}-${m}` : iso;
}

function euro(n: number | null): string {
  if (n === null || Number.isNaN(n)) return '';
  return `€${n.toFixed(2).replace('.', ',')}`;
}

/**
 * Compacte opslag-regel op de order. Alleen weergave: de stand komt uit
 * opslag-stand.ts, dezelfde rekenregel als de cron en de agents.
 */
export function OpslagStandBadge({ opslag }: { opslag: OpslagStand | null | undefined }) {
  if (!opslag || opslag.stand === 'niet-gestart') return null;

  let tekst: string;
  let kleur: string;
  switch (opslag.stand) {
    case 'loopt': {
      const weken = opslag.wekenInRekening ?? opslag.wekenBerekend;
      const bedrag = euro(opslag.bedragInclBtw);
      tekst = `Opslagkosten lopen: klaar-bericht ${datumKort(opslag.anker)}, gratis t/m ${datumKort(opslag.gratisTot)}, ${weken} ${weken === 1 ? 'week' : 'weken'} in rekening${bedrag ? ` (${bedrag})` : ''}`;
      kleur = 'bg-orange-50 border-orange-200 text-orange-900';
      break;
    }
    case 'gratis':
      tekst = `Gratis bewaren t/m ${datumKort(opslag.gratisTot)}`;
      kleur = 'bg-slate-50 border-slate-200 text-slate-700';
      break;
    case 'vrijgesteld':
      tekst = 'Geen opslagkosten (vrijgesteld)';
      kleur = 'bg-emerald-50 border-emerald-200 text-emerald-900';
      break;
    case 'gestopt': {
      const weken = opslag.wekenInRekening ?? 0;
      tekst = weken > 0
        ? `Opslagklok gestopt, ${weken} ${weken === 1 ? 'week' : 'weken'} in rekening`
        : 'Opslagklok gestopt';
      kleur = 'bg-slate-50 border-slate-200 text-slate-700';
      break;
    }
    default:
      return null;
  }

  return (
    <div className={clsx('px-3 py-2 border rounded-md text-xs', kleur)} title={opslag.pauzeTot ? `Reminder-pauze tot ${datumKort(opslag.pauzeTot)}` : undefined}>
      {tekst}
      {opslag.pauzeTot && <span className="text-slate-500"> (pauze tot {datumKort(opslag.pauzeTot)})</span>}
    </div>
  );
}
